import moment from "moment";
import TransportationPermission from './TransportationPermission';

export default class TransportationPermissionInfo {

    permissions: TransportationPermission[] = []
    permissionTypes: string[] = [];
   
    // NOTE: Timit only
    timitPassengerId: number;    
    movitInstanceId: number | null;

    constructor(options) {
        this.permissions = options && options.permissions ? 
            options.permissions.map(t => new TransportationPermission(t)) : [];
        this.permissionTypes = options && options.permissionTypes ? options.permissionTypes : [];   
        this.timitPassengerId = options && options.timitPassengerId ? options.timitPassengerId : null;    
        this.movitInstanceId = options && options.movitInstanceId ? options.movitInstanceId : null;
    }
}
